/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OpenGoal Platform API
 * Agency-facing API — day-to-day platform usage by agency users.
 * OpenAPI spec version: 1.0
 */

export type PlayersControllerListPlayersV1Representation = typeof PlayersControllerListPlayersV1Representation[keyof typeof PlayersControllerListPlayersV1Representation];


export const PlayersControllerListPlayersV1Representation = {
  signed: 'signed',
  prospect: 'prospect',
  other_agency: 'other_agency',
  unrepresented: 'unrepresented',
} as const;
